<template>
  <el-dialog custom-class="pc-dialog pc-dialog__upload-image"
    title="上传图片"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeHandler"
    @open="openHandler"
    >
    <div class="pc-dialog__upload-image-area">
      <div class="pc-dialog__upload-image-empty" v-show="imageEmpty"
        @click="selectFileHandler">
        <div class="icon">
          <i class="el-icon-upload"/>
        </div>
        <div class="options">
          <span>点击当前区域选择本地文件，或</span>
          <el-button type="text" @click.stop="useClipboardHandler">使用当前截图</el-button>
        </div>
        <input type="file" ref="uploadFile" @change="hanleUploadFileChangeHandler" accept="image/jpeg,image/png" />
      </div>
      <div class="pc-dialog__upload-image-preview" v-show="!imageEmpty">
        <img :src="imageSrc"/>
        <!-- <el-button class="reset" size="small" type="text" icon="el-icon-close" circle @click="resetHandler" title="重置"></el-button> -->
        <!-- <span class="reset" @click="resetHandler"><i class="el-icon-circle-close"/></span> -->
      </div>
    </div>
    <div slot="footer" class="pc-dialog__upload-image-footer">
      <el-input v-model="imageFileName" size="small" placeholder="请为图片命名" clearable/>
      <el-button type="primary" size="small" @click="okHandler" :disabled="waiting">上传</el-button>
      <el-button size="small" @click="resetHandler">重置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'
import { isNullOrWhiteSpace } from '@/common/utils'
import { operateError } from '@/common/errors'

export default {
  name: 'UploadImageDialog',
  data () {
    return {
      imageEmpty: true,
      imageSrc: '',
      imageFileName: '',
      waiting: false,
      imageFile: null
    }
  },
  computed: {
    ...mapGetters('dialog', {
      uploadImage: 'uploadImage'
    }),
    visible: {
      get () {
        return this.uploadImage.visible
      },
      set (value) {
        this.setUploadImage({ visible: value })
      }
    }
  },
  methods: {
    ...mapMutations('dialog', {
      setUploadImage: 'SET_UPLOAD_IMAGE'
    }),
    ...mapActions('image', {
      upload: 'uploadImage',
      searchImages: 'searchImages'
    }),
    closeHandler () {
      this.resetHandler()
    },
    openHandler () {},
    selectFileHandler () {
      this.$refs.uploadFile.click()
    },
    hanleUploadFileChangeHandler () {
      const file = this.$refs.uploadFile.files[0]
      if (!file) {
        return
      }
      const that = this
      const reader = new FileReader()
      reader.onload = (e) => {
        that.imageEmpty = false
        that.imageSrc = e.target.result
        that.imageFileName = file.name.split('.')[0]
        that.imageFile = file
      }
      reader.readAsDataURL(file)
    },
    async useClipboardHandler () {
      const result = await navigator.permissions.query({ name: 'clipboard-read' })
      if (result.state === 'granted' || result.state === 'prompt') {
        const data = await navigator.clipboard.read()
        let file = null
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          const imageType = _.find(item.types, type => type.startsWith('image/'))
          if (imageType) {
            file = await item.getType(imageType)
            break
          }
        }
        if (file) {
          const that = this
          const reader = new FileReader()
          reader.onload = (e) => {
            that.imageEmpty = false
            that.imageSrc = e.target.result
            that.imageFileName = ''
            that.imageFile = file
          }
          reader.readAsDataURL(file)
        } else {
          this.$message({
            message: '剪切板中尚无截图数据',
            type: 'warning'
          })
        }
      } else {
        this.$message({
          message: '未授权访问剪切板内容',
          type: 'warning'
        })
      }
    },
    resetHandler () {
      this.$refs.uploadFile.value = null
      this.imageEmpty = true
      this.imageSrc = ''
      this.imageFileName = ''
      this.imageFile = null
    },
    async okHandler () {
      if (!this.imageFile) {
        this.$message({
          message: '未提供图片',
          type: 'warning'
        })
        return
      }
      if (isNullOrWhiteSpace(this.imageFileName)) {
        this.$message({
          message: '请为图片命名',
          type: 'warning'
        })
        return
      }
      const formData = new FormData()
      formData.append('fileName', this.imageFileName)
      formData.append('file', this.imageFile)

      this.waiting = true
      try {
        await this.upload(formData)
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.visible = false
        // this.searchImages({ page: 1 })
      } catch (e) {
        console.dir(e)
        operateError(e, '上传图片')
      } finally {
        this.waiting = false
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-dialog__upload-image-footer {
  display: flex;
  flex-direction: row;
  align-items: center;

  .el-button {
    margin-left: 1rem;
  }
}
</style>
